import {Button} from 'shells/button/button';
import {Message} from 'shells/message/message';
import type {MessageType} from 'shells/message/message';

type Props = {
    onCtaClick: () => void;
    onClose?: () => void;
    ctaMessageType: MessageType;
    icon: React.ComponentType<any>;
    // Optional because occasionally only admins can see the CTA
    ctaText?: string;
    text: string;
};

export function CtaBannerSmall(props: Props) {
    const Icon = props.icon;

    return (
        <Message
            type={props.ctaMessageType}
            lessPadding={true}
            leftAlignContent={true}
            hasBorder={true}
            onClose={props.onClose}
            cta={
                props.ctaText ? (
                    <Button variant='text-primary' size='small' onClick={props.onCtaClick}>
                        {props.ctaText}
                    </Button>
                ) : null
            }
        >
            <div className='mr-12 flex align-center justify-center'>
                <Icon size={16} wrapWithDiv={false} />
            </div>
            <div className='font-size-small'>{props.text}</div>
        </Message>
    );
}
